import { FC } from 'react'
import { useRoutes } from 'react-router-dom'
import useBreadcrumbs from "use-react-router-breadcrumbs"
import { HeaderSiderContentLayout } from './components/layouts/HeaderSiderContentLayout'
import { ContentLayout } from './components/layouts/ContentLayout'
import IndividualRegistration from "./pages/IndividualRegistration"
import IndividualRegistrationConfirm from './pages/IndividualRegistrationConfirm'
import IndividualList from './pages/admin/IndividualList'
import IndividualDetails from './pages/admin/IndividualDetails'
import RefrigerationTemperatures from './pages/admin/RefrigerationTemperatures'
import SearchIndividual from './pages/SearchIndividual'
import CarcassList from './pages/admin/CarcassList'
import RequireAuth from './components/RequireAuth'
import AcceptanceRegistration from './pages/admin/AcceptanceRegistration'
import Hunters from './pages/admin/Hunters'
import FormConfig from './pages/admin/FormConfig'
import HunterRegistration from './pages/HunterRegistration'
import HunterRegistrationConfirm from './pages/HunterRegistrationConfirm'
import HunterDetails from './pages/admin/HunterDetails'
import Customers from './pages/admin/Customers'
import CustomerRegistration from './pages/CustomerRegistration'
import CustomerRegistrationConfirm from './pages/CustomerRegistrationConfirm'
import CustomerDetails from './pages/admin/CustomerDetails'
import ProductList from './pages/admin/ProductList'
import ProductDetails from './pages/admin/ProductDetails'
import MinceProductList from './pages/admin/MinceProductList'
import { BreadcrumbsHunter } from './breadcrumbs/BreadcrumbsHunter'
import { BreadcrumbsCustomer } from './breadcrumbs/BreadcrumbsCustomer'
import { BreadcrumbsIndividual } from './breadcrumbs/BreadcrumbsIndividual'
import ArrivalRegistration from './pages/ArrivalRegistration'
import ArrivalRegistrationConfirm from './pages/ArrivalRegistrationConfirm'
import NotFound from './pages/NotFound'
import { IndividualReceipt } from './pages/IndividualReceipt'
import SearchProduct from './pages/admin/SearchProcuct'
import SearchItems from './pages/admin/SearchItems'
import ShippingRegistration from './pages/admin/ShippingRegistration'
import ShipmentList from './pages/admin/ShipmentList'
import ShipmentDetails from './pages/admin/ShipmentDetails'
import ShipmentSquareCallback from './pages/admin/ShipmentSquareCallback'
import ShipmentDocument from './pages/admin/ShipmentDocument'
import QuotationPreview from './pages/admin/QuotationPreview'
import HygieneManagement from './pages/admin/HygieneManagement'
import HygieneManagementForm from './pages/admin/HygieneManagementForm'
import DailyHygieneManagement from './pages/admin/DailyHygieneManagement'
import DailyHygieneManagementForm from './pages/admin/DailyHygieneManagementForm'
import WeeklyHygieneManagement from './pages/admin/WeeklyHygieneManagement'
import WeeklyHygieneManagementForm from './pages/admin/WeeklyHygieneManagementForm'
import HealthCheck from './pages/admin/HealthCheck'
import HealthCheckDocument from './pages/admin/HealthCheckDocument'
import PestControlManagement from './pages/admin/PestControlManagement'
import PestControlManagementForm from './pages/admin/PestControlManagementForm'
import NotificationCategories from './pages/admin/NotificationCategories'
import BusinessHolidays from './pages/admin/BusinessHolidays'
import { Navigate } from 'react-router-dom'
import Parts from './pages/admin/Parts'
import Users from './pages/admin/Users'
import CompanySettings from './pages/admin/CompanySettings'
import Employees from './pages/admin/Employees'
import HealthCheckRespond from './pages/HealthCheckRespond'

type Props = object

// eslint-disable-next-line react-refresh/only-export-components
export const routes: Parameters<typeof useBreadcrumbs>[0] = [
  {
    element: <ContentLayout />,
    children: [
      {
        path: '/',
        element: <RequireAuth><SearchIndividual /></RequireAuth>,
        breadcrumb: ""
      },
      {
        path: '/hunters/:hunterId/regist',
        element: <RequireAuth><HunterRegistration /></RequireAuth>,
        breadcrumb: "狩猟者登録"
      },
      {
        path: '/hunters/:hunterId/confirm',
        element: <RequireAuth><HunterRegistrationConfirm /></RequireAuth>,
        breadcrumb: "狩猟者登録"
      },
      {
        path: '/customers/:customerId/regist',
        element: <RequireAuth><CustomerRegistration /></RequireAuth>,
        breadcrumb: "取引先登録"
      },
      {
        path: '/customers/:customerId/confirm',
        element: <RequireAuth><CustomerRegistrationConfirm /></RequireAuth>,
        breadcrumb: "取引先登録"
      },
      {
        path: '/individuals/:individualId/regist',
        element: <RequireAuth><IndividualRegistration /></RequireAuth>,
        breadcrumb: "個体情報登録"
      },
      {
        path: '/individuals/:individualId/confirm',
        element: <RequireAuth><IndividualRegistrationConfirm /></RequireAuth>,
        breadcrumb: "個体情報登録"
      },
      {
        path: '/individuals/:individualId/arrival/regist',
        element: <RequireAuth><ArrivalRegistration /></RequireAuth>,
        breadcrumb: "捕獲個体到着登録"
      },
      {
        path: '/individuals/:individualId/arrival/confirm',
        element: <RequireAuth><ArrivalRegistrationConfirm /></RequireAuth>,
        breadcrumb: null
      },
      {
        path: '/individuals/:individualNo',
        element: <SearchIndividual />,
        breadcrumb: "個体情報"
      },
      {
        path: '/individuals/:individualId/receipt',
        element: <RequireAuth><IndividualReceipt /></RequireAuth>,
        breadcrumb: "個体預かり票"
      },
      {
        path: '/health-check/:id',
        element: <RequireAuth><HealthCheckRespond /></RequireAuth>,
        breadcrumb: null
      },
      {
        path: "noData",
        element: <NotFound />,
        breadcrumb: null
      },
      {
        path: "*",
        element: <NotFound />,
        breadcrumb: null
      }
    ],
  },
  {
    element: <HeaderSiderContentLayout />,
    children: [
      {
        path: '/admin',
        element: <RequireAuth><IndividualList /></RequireAuth>,
        breadcrumb: ""
      },
      {
        path: '/admin/individual/add',
        element: <RequireAuth><AcceptanceRegistration /></RequireAuth>,
        breadcrumb: "個体受入登録"
      },
      {
        path: '/admin/individuals',
        element: <RequireAuth><IndividualList /></RequireAuth>,
        breadcrumb: "受入個体一覧"
      },
      {
        path: '/admin/hunters',
        element: <RequireAuth><Hunters /></RequireAuth>,
        breadcrumb: "狩猟者一覧"
      },
      {
        path: '/admin/customers',
        element: <RequireAuth><Customers /></RequireAuth>,
        breadcrumb: "取引先一覧"
      },
      {
        path: '/admin/hunters/:hunterId',
        element: <RequireAuth><HunterDetails /></RequireAuth>,
        breadcrumb: BreadcrumbsHunter,
      },
      {
        path: '/admin/customers/:customerId',
        element: <RequireAuth><CustomerDetails /></RequireAuth>,
        breadcrumb: BreadcrumbsCustomer,
      },
      {
        path: '/admin/individuals',
        element: <RequireAuth><IndividualList /></RequireAuth>,
        breadcrumb: "受入個体一覧"
      },
      {
        path: '/admin/carcass',
        element: <RequireAuth><CarcassList /></RequireAuth>,
        breadcrumb: "枝肉一覧（熟成庫）"
      },
      {
        path: '/admin/products',
        element: <RequireAuth><ProductList /></RequireAuth>,
        breadcrumb: "製品一覧（出荷先）"
      },
      {
        path: '/admin/products/:individualId',
        element: <RequireAuth><ProductDetails /></RequireAuth>,
        breadcrumb: BreadcrumbsIndividual
      },
      {
        path: '/admin/mince-products',
        element: <RequireAuth><MinceProductList /></RequireAuth>,
        breadcrumb: "ミンチ製品一覧"
      },
      {
        path: '/admin/individuals/:individualId',
        element: <RequireAuth><IndividualDetails /></RequireAuth>,
        breadcrumb: BreadcrumbsIndividual
      },
      {
        path: '/admin/config/forms',
        element: <RequireAuth><FormConfig /></RequireAuth>,
        breadcrumb: "フォーム定義設定"
      },
      {
        path: '/admin/devices/refrigeration',
        element: <RequireAuth><RefrigerationTemperatures /></RequireAuth>,
        breadcrumb: "冷蔵温度推移"
      },
      {
        path: '/admin/search/product',
        element: <RequireAuth><SearchProduct /></RequireAuth>,
        breadcrumb: "商品番号検索"
      },
      {
        path: '/admin/search/items',
        element: <RequireAuth><SearchItems /></RequireAuth>,
        breadcrumb: "商品検索"
      },
      {
        path: '/admin/shipping/register',
        element: <RequireAuth><ShippingRegistration /></RequireAuth>,
        breadcrumb: "未出荷リスト"
      },
      {
        path: '/admin/shipments',
        element: <RequireAuth><ShipmentList /></RequireAuth>,
        breadcrumb: "出荷一覧"
      },
      {
        path: '/admin/shipments/square-callback',
        element: <RequireAuth><ShipmentSquareCallback /></RequireAuth>,
        breadcrumb: "Square決済結果"
      },
      {
        path: '/admin/shipments/:shipmentId',
        element: <RequireAuth><ShipmentDetails /></RequireAuth>,
        breadcrumb: "出荷詳細"
      },
      {
        path: '/admin/shipments/:shipmentId/document/:type',
        element: <RequireAuth><ShipmentDocument /></RequireAuth>,
        breadcrumb: "帳票"
      },
      {
        path: '/admin/quotation/preview',
        element: <RequireAuth><QuotationPreview /></RequireAuth>,
        breadcrumb: "見積書プレビュー"
      },
      {
        path: '/admin/daily-hygiene-management',
        element: <RequireAuth><DailyHygieneManagement /></RequireAuth>,
        breadcrumb: "衛生管理点検票（日次）"
      },
      {
        path: '/admin/daily-hygiene-management/new',
        element: <RequireAuth><DailyHygieneManagementForm /></RequireAuth>,
        breadcrumb: "新規作成"
      },
      {
        path: '/admin/daily-hygiene-management/:id',
        element: <RequireAuth><DailyHygieneManagementForm /></RequireAuth>,
        breadcrumb: "編集"
      },
      {
        path: '/admin/weekly-hygiene-management',
        element: <RequireAuth><WeeklyHygieneManagement /></RequireAuth>,
        breadcrumb: "衛生管理点検票（週次）"
      },
      {
        path: '/admin/weekly-hygiene-management/:weekId',
        element: <RequireAuth><WeeklyHygieneManagementForm /></RequireAuth>,
        breadcrumb: "編集"
      },
      {
        path: '/admin/health-check',
        element: <RequireAuth><HealthCheck /></RequireAuth>,
        breadcrumb: "従業員健康チェック表"
      },
      {
        path: '/admin/health-check/:employeeId/document',
        element: <RequireAuth><HealthCheckDocument /></RequireAuth>,
        breadcrumb: "PDF出力"
      },
      {
        path: '/admin/hygiene-management',
        element: <RequireAuth><HygieneManagement /></RequireAuth>,
        breadcrumb: "衛生管理点検票（月次）"
      },
      {
        path: '/admin/hygiene-management/new',
        element: <RequireAuth><HygieneManagementForm /></RequireAuth>,
        breadcrumb: "新規作成"
      },
      {
        path: '/admin/hygiene-management/:id',
        element: <RequireAuth><HygieneManagementForm /></RequireAuth>,
        breadcrumb: "編集"
      },
      {
        path: '/admin/pest-control-management',
        element: <RequireAuth><PestControlManagement /></RequireAuth>,
        breadcrumb: "そ族昆虫防除記録"
      },
      {
        path: '/admin/pest-control-management/new',
        element: <RequireAuth><PestControlManagementForm /></RequireAuth>,
        breadcrumb: "新規作成"
      },
      {
        path: '/admin/pest-control-management/:id',
        element: <RequireAuth><PestControlManagementForm /></RequireAuth>,
        breadcrumb: "編集"
      },
      {
        path: '/admin/notification-categories',
        element: <RequireAuth><NotificationCategories /></RequireAuth>,
        breadcrumb: "通知カテゴリ管理"
      },
      {
        path: '/admin/business-holidays',
        element: <RequireAuth><BusinessHolidays /></RequireAuth>,
        breadcrumb: "休業日マスタ"
      },
      {
        path: '/admin/part-prices',
        element: <Navigate to="/admin/parts" replace />,
        breadcrumb: null
      },
      {
        path: '/admin/parts',
        element: <RequireAuth><Parts /></RequireAuth>,
        breadcrumb: "部位マスタ"
      },
      {
        path: '/admin/users',
        element: <RequireAuth><Users /></RequireAuth>,
        breadcrumb: "ユーザー管理"
      },
      {
        path: '/admin/employees',
        element: <RequireAuth><Employees /></RequireAuth>,
        breadcrumb: "従業員マスタ"
      },
      {
        path: '/admin/settings/company',
        element: <RequireAuth><CompanySettings /></RequireAuth>,
        breadcrumb: "会社設定"
      }
    ],
  },
]

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RoutesComponent: FC<Props> = (_props) => {
  const element = useRoutes(routes)
  return element
}

export default RoutesComponent
